module.exports = __webpack_public_path__ + "media/images/icon-edu-card-darkpurple-38e961341afb15cf92c71e7d73538605.svg";